import { formatDate } from '@/portainer/filters/filters';

import { StatusBadgeType } from '@@/StatusBadge';

import {
  Alert,
  AlertRulesGroupsResponse,
  AlertState,
  AlertRuleRow,
  ActiveAlertsResponse,
  ActiveAlertRow,
} from './types';

export function transformToActiveAlertRows(
  response: ActiveAlertsResponse
): ActiveAlertRow[] {
  return response.flatMap((alertGroup) =>
    alertGroup.Payload.map((alert) => ({
      id: alert.labels.alert_id,
      fingerprint: alert.fingerprint,
      alertName: alert.labels.alertname,
      description: alert.annotations.description,
      message: alert.annotations.message,
      category: alert.labels.category,
      severity: alert.labels.severity,
      state: alert.status.state,
      source: alert.labels.source,
      instance: alert.labels.instance,
      startsAt: new Date(alert.startsAt),
      endsAt: new Date(alert.endsAt),
      updatedAt: new Date(alert.updatedAt),
      createdAt: new Date(alert.annotations.created_at),
      createdBy: alert.annotations.created_by,
      receivers: alert.receivers.map((r) => r.name),
      labels: Object.fromEntries(
        Object.entries(alert.labels).filter(([, value]) => value !== undefined)
      ) as Record<string, string>,
      alertRuleId: alert.labels.alert_rule_id,
    }))
  );
}

// Legacy transformation function for backward compatibility
export function transformToAlertRuleRows(
  response: AlertRulesGroupsResponse
): AlertRuleRow[] {
  return response.groups.flatMap((group) =>
    group.rules.map((rule) => ({
      id: rule.name,
      summary: rule.annotations.summary,
      description: rule.annotations.description,
      environmentName: rule.labels.portainer_io_environment_name,
      orchestrationType: rule.labels.portainer_io_environment_orchestration,
      severity: rule.labels.severity,
      lastChecked: new Date(rule.lastEvaluation),
      lastFired: rule.alerts.length > 0 ? getLastFired(rule.alerts) : null,
      alerts: rule.alerts.map((alert) => ({
        activeAt: new Date(alert.activeAt),
        state: alert.State,
        summary: alert.Annotations.summary,
        description: alert.Annotations.description,
      })),
      alertState: rule.state,
    }))
  );
}

// get the date of the last alert that was fired
function getLastFired(alerts: Array<Alert>) {
  const firingAlerts = alerts.filter((alert) => alert.State === 'firing');
  if (firingAlerts.length === 0) {
    return null;
  }
  const sortedFiringAlerts = firingAlerts.sort(
    (a, b) => new Date(b.activeAt).getTime() - new Date(a.activeAt).getTime()
  );
  const lastFiredDate = new Date(sortedFiringAlerts[0].activeAt);
  return formatDate(lastFiredDate);
}

export const statusToBadgeType: Record<AlertState, StatusBadgeType> = {
  active: 'danger',
  firing: 'danger',
  inactive: 'success',
  pending: 'warning',
};
